// Helpers to read flexible Excel/CSV columns (case-insensitive, accent-insensitive, ES/EN)

function normalize(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9]/g, "")
    .trim();
}

export function pickField(row, ...names) {
  const keys = Object.keys(row || {});
  const want = names.map(normalize);
  for (const k of keys) {
    if (want.includes(normalize(k))) {
      const v = row[k];
      if (v !== undefined && v !== null && v !== "") return v;
    }
  }
  return "";
}

export function detectHeaders(rows) {
  if (!rows || !rows.length) return [];
  return Object.keys(rows[0]);
}
